export type PaymentFailureKind = 'declined' | 'upstream';

function readUpstreamCode(error: any): number | null {
  const raw = error?.detail?.error_details?.error_code ?? error?.error_details?.error_code;
  const code = Number(raw);

  return Number.isFinite(code) ? code : null;
}

export function classifyPaymentFailure(error: unknown): PaymentFailureKind {
  const upstream = readUpstreamCode(error);
  if (upstream !== null && upstream >= 500) return 'upstream';

  const status = Number((error as any)?.status ?? (error as any)?.detail?.status);

  return Number.isFinite(status) && status >= 500 ? 'upstream' : 'declined';
}

export function isOutcomeUnknown(error: unknown): boolean {
  return classifyPaymentFailure(error) === 'upstream';
}
